import React from 'react';
import PropTypes from 'prop-types';

import { Switch, Typography } from '@sm/wds-react';

const EmailPreferenceItem = ({ title, description, name, isSubscribed, handleChange }) => (
  <div className="wds-flex wds-m-b-6">
    <span className="wds-flex__item--grow wds-m-r-6">
      <Typography component="div" variant="cardTitle">
        {title}
      </Typography>
      <Typography component="div" color="dark-muted">
        {description}
      </Typography>
    </span>
    <span>
      <Switch checked={isSubscribed} id={name} onChange={handleChange} />
    </span>
  </div>
);

EmailPreferenceItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isSubscribed: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

EmailPreferenceItem.defaultProps = {
  isSubscribed: false,
};

export default EmailPreferenceItem;
